var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 70,
    viewBox: "0 0 75 70",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M39.135 35.5a1.001 1.001 0 0 0 .872 1.5h11.986a1 1 0 1 0 0-2H41V11.003a1 1 0 1 0-2 0v23.994a1 1 0 0 0 .135.502zM5.186 38.634C7.005 56.257 21.897 70 40 70c19.33 0 35-15.67 35-35S59.33 0 40 0C22.66 0 8.265 12.61 5.485 29.16A1 1 0 0 0 6.031 31a1 1 0 0 0 1.006-1h.34C9.785 14.147 23.473 2 40 2c18.225 0 33 14.775 33 33S58.225 68 40 68C23.13 68 9.218 55.343 7.24 39.007l3.536 3.535a1 1 0 0 0 1.415-.006 1.007 1.007 0 0 0 .007-1.415l-5.663-5.663a.997.997 0 0 0-1.396-.012 1 1 0 0 0-.48.376l-4.48 6.64a1.007 1.007 0 0 0 .277 1.388 1 1 0 0 0 1.39-.264z"
  })));
});
const SvgReportInProgressIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportInProgressIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NSIgaGVpZ2h0PSI3MCIgdmlld0JveD0iMCAwIDc1IDcwIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTM5LjEzNSAzNS41YTEuMDAxIDEuMDAxIDAgMCAwIC44NzIgMS41aDExLjk4NkM1Mi41NSAzNyA1MyAzNi41NTIgNTMgMzZjMC0uNTU2LS40NS0xLTEuMDA3LTFINDFWMTEuMDAzYTEgMSAwIDEgMC0yIDB2MjMuOTk0YTEgMSAwIDAgMCAuMTM1LjUwMnpNNS4xODYgMzguNjM0QzcuMDA1IDU2LjI1NyAyMS44OTcgNzAgNDAgNzBjMTkuMzMgMCAzNS0xNS42NyAzNS0zNVM1OS4zMyAwIDQwIDBDMjIuNjYgMCA4LjI2NSAxMi42MSA1LjQ4NSAyOS4xNkExIDEgMCAwIDAgNi4wMzEgMzFhMSAxIDAgMCAwIDEuMDA2LTFoLjM0QzkuNzg1IDE0LjE0NyAyMy40NzMgMiA0MCAyYzE4LjIyNSAwIDMzIDE0Ljc3NSAzMyAzM1M1OC4yMjUgNjggNDAgNjhDMjMuMTMgNjggOS4yMTggNTUuMzQzIDcuMjQgMzkuMDA3bDMuNTM2IDMuNTM1YS45OTguOTk4IDAgMCAwIDEuNDE1LS4wMDYgMS4wMDcgMS4wMDcgMCAwIDAgLjAwNy0xLjQxNWwtNS42NjMtNS42NjNhLjk5Ny45OTcgMCAwIDAtMS4zOTYtLjAxMi45ODcuOTg3IDAgMCAwLS40OC4zNzZsLTQuNDggNi42NGExLjAwNyAxLjAwNyAwIDAgMCAuMjc3IDEuMzg4Ljk5OC45OTggMCAwIDAgMS4zOS0uMjY0bDMuMzQtNC45NTF6Ii8+Cjwvc3ZnPgo=";